import { XGridInlineEdit } from 'app/components/Common/XGrid/XGridInlineEdit';
import React, { useEffect, useState } from 'react';
import { GridColumns, GridCellParams } from '@mui/x-data-grid-pro';
import { XGridDefaultColumn } from 'app/components/Common/XGrid/cells/XGridDefaults';
import { XGridChipCell } from '@AMIEWEB/Common';
import XGridTaskCell from '../PlacementModsGrid/XGridTaskCell';
import { getEndOfDate } from 'app/helpers/dateHelper';
import {
  getAmount,
  getColor,
  gridFilterRowCount,
  statusHandler,
  batchModResponseHandler,
} from '../ModificationsUtils';
import { colors } from 'styles/styleVariables';
import { makeStyles } from 'tss-react/mui';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { usePromiseTracker } from 'react-promise-tracker';
import { useParams } from 'react-router-dom';
import { selectPlacementModificationTabRendered } from 'store/redux-store/placement-details/selectors';
import { placementDetailsAction } from 'store/redux-store/placement-details/slice';
import { formatDate } from '@AMIEWEB/Order/OrderDetails/helper';
import { missingField } from 'app/constants';
import { selectFiterAttributes } from '@AMIEWEB/Common/Grid/GridStateManagement/GridState.selectors';
import {
  IPlacementHistoryFilters,
  PlacementHistoryFilterName,
  PlacementHistoryVisibilityModel,
} from './PlacementHistoryFilterUtils';
import { XGridOverflowCell } from '@AMIEWEB/Common/XGrid/cells/XGridOverflowCell';
import {
  selectModSavedStatus,
  selectPlacementModificationHistory,
  selectIsEmiLmoDisabled,
  selectIsEditMod
} from 'store/redux-store/placement-mods/selectors';
import { gridStateActions } from '@AMIEWEB/Common/Grid/GridStateManagement/GridState.redux';
import { XGridClickableCell } from '../PlacementModsGrid/XGridClickableCell';
import { GridState } from '@mui/x-data-grid';
import { isReadOnly, isRecruitment } from 'oidc/userRoles';
import { IXGridBulkActionButton } from '@AMIEWEB/Common/XGrid/Toolbar/XGridToolbar';
import { selectUser } from 'oidc/user.selectors';
import { ReplaceTasks } from '../CommonComponents/ReplaceTasks/ReplaceTasks';
import LinkIcon from '@mui/icons-material/Link';
import LinkOffIcon from '@mui/icons-material/LinkOff';
import { UnLinkTasks } from '../CommonComponents/UnLinkTasks/UnLinkTasks';
import { placementModsAction } from 'store/redux-store/placement-mods/slice';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import { selectGridSelection } from '@AMIEWEB/Common/Grid/GridSelection/GridSelection.selector';
import { selectPlacementStatus } from 'store/redux-store/placement-status/selectors';
import { IPlacementHistoryRequest } from 'app/models/Placement/PlacementMods';
import _, { flatten } from 'lodash';
import { AcceptenceStatus } from 'app/models/Placement/PlacementMods';
import { PromiseTrackerKeys } from 'app/constants/PromiseTrackerKeys';
import { gridSelectionActions } from '@AMIEWEB/Common/Grid/GridSelection/GridSelection.redux';
import { GridRowsProp } from '@mui/x-data-grid-pro';
import { selectUserPreference } from 'oidc/UserDevicePreference/userPreference.selectors';
import { userDevicePreferenceActions } from 'oidc/UserDevicePreference/userPreference.redux';
import { RootState } from 'types';
import { gridTags, MODIFICATIONS_GRID_PAGE_SIZE } from 'app/models/Placement/PlacementMods';
import { GridColumns as CurrentGridColumns } from 'app/models/GlobalSearch/GlobalSearch';
import { GridColumns as XGridColumns } from '@mui/x-data-grid-pro';
import { GridColumnVisibilityModel, GridPinnedColumns, GridDensity, GridFilterModel } from '@mui/x-data-grid-pro';
import { usePinnedColumnsPreference, useSortModelPreference, useGetSortModelPreferences } from 'app/components/Common/XGrid/Hooks';
import { generateSafeId } from 'app/helpers/objectHelpers';

const useStyles = makeStyles<{ totalRows: number }>()((theme, props) => ({
  grid: {
    fontSize: '14px',
    '& .MuiDataGrid-toolbarContainer': {
      border: '1px solid rgba(224, 224, 224, 1)',
      borderTopLeftRadius: '4px',
      borderTopRightRadius: '4px',
    },
  },
  typography: {
    fontSize: '14px',
    fontWeight: '400',
    color: colors.amnLightBlue,
    cursor: 'pointer',
  },
  voidedCell: {
    backgroundColor: theme.palette.framework.system.backgroundGrey,
  },
}));

const getAcceptanceStatusOptions = (acceptanceStatusOptions: [{key: number, value: string}]) => {
  let acceptanceOptions = ['Accepted', 'Declined'];

  if (acceptanceStatusOptions) {
    acceptanceOptions =  acceptanceStatusOptions.map(option => option.value);
  }

  return acceptanceOptions;
}

const PlacementHistoryGrid = ({
  onModsDetailsClick,
  resetGridParams,
  setResetGridParams,
}: {
  onModsDetailsClick: any;
  resetGridParams: any;
  setResetGridParams: any;
}) => {
  const placementHistoryColumn = (): GridColumns => [
    {
      ...XGridDefaultColumn,
      field: 'type',
      headerName: 'Type',
      flex: 0,
      width: 125,
      renderCell: XGridOverflowCell(XGridClickableCell(onModsDetailsClick, true))(
        XGridClickableCell(onModsDetailsClick),
      ),
    },
    {
      ...XGridDefaultColumn,
      field: 'description',
      headerName: 'Description',
      flex: 0,
      width: 178,
    },
    {
      ...XGridDefaultColumn,
      field: 'standard',
      headerName: 'Standard',
      flex: 0,
      width: 100,
    },
    {
      ...XGridDefaultColumn,
      field: 'amount',
      headerName: 'Amount',
      flex: 0,
      width: 100,
      align: 'right',
      renderCell: params => {
        return getAmount(params?.value);
      },
    },
    {
      ...XGridDefaultColumn,
      field: 'acceptance',
      headerName: 'Acceptance',
      flex: 0,
      width: 100,
      editable: true,
      type: 'singleSelect',
      valueOptions: params => {
      return getAcceptanceStatusOptions(params.row.acceptanceOptions)
    },
    },
    {
      ...XGridDefaultColumn,
      field: 'status',
      headerName: 'Status',
      flex: 0,
      width: 150,
      renderCell: XGridChipCell({
        size: 'small',
        dynamicColor: (params: GridCellParams) => {
          return getColor(params.value);
        },
        renderValue: (params: GridCellParams) => {
          return params.value;
        },
      }),
    },

    {
      ...XGridDefaultColumn,
      field: 'approvedBy',
      headerName: 'Approved By',
      flex: 0,
      width: 155,
    },
    {
      ...XGridDefaultColumn,
      field: 'approvalDate',
      headerName: 'Approval Date',
      flex: 0,
      width: 183,
    },
    {
      ...XGridDefaultColumn,
      field: 'effectiveDate',
      headerName: 'Effective Date',
      flex: 0,
      width: 100,
    },
    {
      ...XGridDefaultColumn,
      field: 'task',
      headerName: 'Task',
      flex: 0,
      width: 60,
      renderCell: params => <XGridTaskCell hasTask={params.value} params={params} />,
    },
    {
      ...XGridDefaultColumn,
      field: 'recruiterApproved',
      headerName: 'Recruiter Approved',
      flex: 0,
      width: 163,
      renderCell: params => {
        return getDate(params?.value);
      },
    },
    {
      ...XGridDefaultColumn,
      field: 'byRecruiter',
      headerName: 'By Recruiter',
      flex: 0,
      width: 110,
    },
    {
      ...XGridDefaultColumn,
      field: 'lastUpdated',
      headerName: 'Last Updated',
      minWidth: 170,
      renderCell: params => {
        return getDate(params?.value);
      },
    },
  ];
  const initialPageSize = MODIFICATIONS_GRID_PAGE_SIZE;
  const { promiseInProgress: isCallingAPI } = usePromiseTracker({ area: 'get-placement-modification', delay: 0 });
  const { promiseInProgress: isSavingMods } = usePromiseTracker({ area: PromiseTrackerKeys.placements.bulkUpdateMods, delay: 0 });
  
  // Combine all saving states
  const isSavingInProgress = isSavingMods;
  
  const historyMods = useSelector(selectPlacementModificationHistory);
  const [pageNumber, setPageNumber] = useState(1);
  const tabRendered = useSelector(selectPlacementModificationTabRendered);
  const [sortedColumn, setSortedColumn] = useState<any>([]);
  const params = useParams<{ placementId: string }>();
  const [rowsToDisplay, setRowsToDisplay] = useState([]);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { classes } = useStyles({ totalRows: rowsToDisplay.length });
  const [historyTableCol, setHistoryTableCol] = useState<any>(placementHistoryColumn());
  const gridTag = gridTags.MODS_HISTORY_GRIDTAG;
  const [currentColumnVisibilityModel, setCurrentColumnVisibilityModel] = React.useState<any>(
    _.cloneDeep(PlacementHistoryVisibilityModel),
  );
  const gridFilters = useSelector(selectFiterAttributes);
  const modSavedResponse = useSelector(selectModSavedStatus);
  const [totalCount, setTotalCount] = useState<number>(0);
  const headerHeight = 70;
  const borderWidth = 1 * 2;
  const toolbarHeight = 10;
  const scrollBarWidth = 12;
  const rowHeight = 36;
  const gridMaxHeight = 75 * rowHeight;
  const maxCount = 75;
  const gridMinHeight =
    rowsToDisplay.length > 0 && rowsToDisplay.length < maxCount ? rowsToDisplay.length * rowHeight : 200;
  const [gridHeight, setGridHeight] = useState<number>(gridMinHeight);
  const [gridParams, setGridParams] = useState<IPlacementHistoryRequest>({
    pageNumber: 1,
    pageSize: initialPageSize,
    placementId: Number(params.placementId),
    offSet: 0,
    gridType: null, 
  });
  const appUser = useSelector(selectUser);
  const isEmiLmoDisabled = useSelector(selectIsEmiLmoDisabled);
  const isModEdit = useSelector(selectIsEditMod);
  const [addIconDisable, setAddIconDisable] = useState(true);
  const [selectedRowDetails, setSelectedRowDetails] = useState([]);
  const [openReplaceTasks, setOpenReplaceTasks] = useState(false);
  const [openUnlink, setOpenUnlink] = useState(false);
  const [rowSelectionModel, setRowSelectionModel] = useState([]);
  const { selectedData: gridSelections } = useSelector(selectGridSelection);
  const placementStatus = useSelector(selectPlacementStatus);
  const [xgridMinHeight, setXgridMinHeight] = useState<number>(gridMinHeight);
  const userPreference = useSelector(selectUserPreference);
  const gridPreferences = useSelector((state: RootState) => {
    return state.userPreferenceData.userGridPreferences.find(item => item.id === gridTag);
  });
  const [pinnedColumns, setPinnedColumns] = React.useState<GridPinnedColumns>({});
  const [filterModel, setFilterModel] = React.useState<GridFilterModel>({ items: [] });
  const [density, setDensity] = React.useState<GridDensity>('compact');
  const [showResetButton, setShowResetButton] = React.useState<boolean>(false);
  const expectedResetVisibilityModelRef = React.useRef<GridColumnVisibilityModel | null>(null);

  const { currentPlacementStatus } = placementStatus;
  const currentActivityTypeId = currentPlacementStatus?.activityTypeId;
  const currentActivityStatusId = currentPlacementStatus?.activityStatusId;
  const getDate = value => {
    return value ? formatDate(value, 'dateAnd12HourTime') : missingField;
  };

  const getRowClassName = (params) => {
    return params.row.voidStatus === 'Y' ? classes.voidedCell : '';
  };

  const onCellDoubleClick = params => {
    onModsDetailsClick(params, 'double');
  };

  const getIsNonTravelerOption = () => {
    // If Placement Type is Booking (Activity Type = 4) AND Placement Status is 
    // Booking Approved (statusId = 14) OR
    // Waiting Good To Go (statusId = 15) OR
    // Postponement warning (statusId = 17) OR
    // Good To Go (statusId = 18)

    if (currentActivityTypeId === 4 && (currentActivityStatusId === 14 || currentActivityStatusId === 15
        || currentActivityStatusId === 17 || currentActivityStatusId === 18)) {
        return true;
    }

    // If Placement Type is Assignment (Activity Type = 5) AND Placement Status is 
    // On Assignment (statusId = 23) OR
    // Assignment Complete (statusId = 24) OR
    // Canceled by Traveler (statusId = 25) OR
    // Canceled by Facility (statusId = 26) OR
    // Canceled by AMH (statusId = 27) OR
    // Canceled by Settlement (statusId = 29)

    if (currentActivityTypeId === 5 && (currentActivityStatusId === 23 || currentActivityStatusId === 24
        || currentActivityStatusId === 25 || currentActivityStatusId === 26
        || currentActivityStatusId === 27 || currentActivityStatusId === 29)) {
        return true;
    }
    return false   
  }

  const isNonTravelerOption = getIsNonTravelerOption();

  const isCellEditable = React.useCallback((params: any, cellName: string) => {
    let isEditable = false;
    const selectRowDetail = rowsToDisplay.find(row => row.id === params.id);

    if (selectRowDetail?.id && cellName === 'acceptanceStatus') {
      // Only allow editing if not in read-only mode and not saving
      isEditable = !isModEdit && !isNonTravelerOption && !isEmiLmoDisabled && !isSavingInProgress;
    }

    return isEditable;
  }, [rowsToDisplay, appUser?.userInfo?.roles, isSavingInProgress]);

  const calcGridHeight = (rows: number) => {
    if (rows >= maxCount) {
      // For infinite scrolling, set a fixed height that allows scrolling
      // Use a reasonable height that shows about 20-25 rows at once
      const scrollableHeight = 600; // Fixed height for scrolling
      setGridHeight(scrollableHeight);
      setXgridMinHeight(200);
    } else if (rows > 0 && rows < maxCount) {
      const height = borderWidth + headerHeight + toolbarHeight + scrollBarWidth + rowHeight * rows;
      setGridHeight(gridMinHeight >= height ? gridMinHeight : height);
      setXgridMinHeight(gridMinHeight >= height ? gridMinHeight : height);
    } else {
      setGridHeight(200);
      setXgridMinHeight(200);
    }
  };

  // Force height calculation when component mounts or when totalCount changes
  useEffect(() => {
    if (totalCount > 0) {
      if (totalCount > maxCount) {
        // Force infinite scrolling height
        setGridHeight(600);
        setXgridMinHeight(200);
      } else {
        calcGridHeight(rowsToDisplay.length);
      }
    }
  }, [totalCount]);

  const handleTaskGridOpen = (event: any) => {
    const isExisting = selectedRowDetails?.some(arr => arr.task);
    if (isExisting) {
      setOpenReplaceTasks(true);
    } else {
      // setOpenTaskGrid(event.currentTarget);
      dispatch(placementModsAction.setOpenTaskGrid(selectedRowDetails));
    }
  };

  useEffect(() => {
    calcGridHeight(rowsToDisplay.length);
    setSelectedRowDetails([]);
    setRowSelectionModel([]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowsToDisplay]);

  // Add effect to recalculate height when total count changes
  useEffect(() => {
    if (totalCount > maxCount) {
      // Force recalculation for infinite scrolling
      calcGridHeight(rowsToDisplay.length);
    }
  }, [totalCount, rowsToDisplay.length]);

  const handleEmptyField = (param: any) => {
    return param ? param : missingField;
  };

  const onUnLinkClick = () => {
    setOpenUnlink(true);
  };

  const formatPendingTableData = (rows: any) => {
    const mappedData = rows.map((item, index) => ({
      ...item,
      totalCount: item.totalCount,
      id: generateSafeId(),
      amount: item.amount,
      travelerOptionId: item.travelerOptionId ? item.travelerOptionId : 0,
      type: handleEmptyField(item.descTravelerOptionType),
      description: handleEmptyField(item.description),
      assignTaskId: item.assignTaskId,
      acceptance: handleEmptyField(item.descAcceptanceStatus),
      status: statusHandler(item.approvalStatusId, item.voidStatus),
      approvedBy: handleEmptyField(item.approvedByName),
      task: item.hasAssignedTask === 'Y' ? true : false,
      recruiterApproved: item.recruiterApprovalDate,
      approvalDate: item.approvalDate ? formatDate(item.approvalDate, 'dateAnd12HourTimeWithSecs') : missingField,
      effectiveDate: item.effectiveDate ? formatDate(item.effectiveDate) : missingField,
      byRecruiter: handleEmptyField(item.recruiterApprovedByName),
      lastUpdated: item.lastUpdated,
      standard: handleEmptyField(item.standard),
      isBookingApprovedOrGreater: item.isBookingApprovedOrGreater,
    }));
    if (mappedData && mappedData.length > 0) {
      setTotalCount(mappedData[0]?.totalCount);
    } else {
      setTotalCount(0);
    }
    return mappedData;
  };

  const getPayloadWithFilters = () => {
    let payload = {};
    const keys = Object.keys(gridFilters?.selectedChipFilters);
    let accecptedKeys = [];
    keys?.forEach(key => {
      setAppliedFiltersByKey(key, payload, accecptedKeys);
    });
    setRawFilter(accecptedKeys, payload);
    return payload;
  };

  const setAppliedFiltersByKey = (key, payload, accecptedKeys) => {
    const filters = gridFilters?.selectedChipFilters[key];
    if (filters) {
      accecptedKeys.push(key);
      switch (key) {
        case PlacementHistoryFilterName.effectiveDate:
          const startDate = filters[0]?.startDate as Date;
          const endDate = filters[0]?.endDate as Date;
          payload['startDate'] = new Date(Date.UTC(startDate.getFullYear(), startDate.getMonth(), startDate.getDate()));
          payload['endDate'] = new Date(
            Date.UTC(endDate.getFullYear(), endDate.getMonth(), endDate.getDate(), 23, 59, 59),
          );
          break;
        case PlacementHistoryFilterName.recruiterApproved || PlacementHistoryFilterName.voidStatus:
          payload[key] = filters[0]?.value;
          break;
        default:
          payload[key] = filters?.length > 0 ? filters?.map(filter => filter?.id)?.toString() : undefined;
          break;
      }
    }
  };

  const onRowsSelectionHandler = ids => {
    setRowSelectionModel(ids);
    setSelectedRowDetails(rowsToDisplay?.filter(val => ids.includes(val.id)));
  };

  const saveUnlinkMods = () => {
    const payload = {
      assignTaskId: null,
      assignRootTaskId: null,
      placementId: parseInt(params.placementId),
      travelerOptionIds: selectedRowDetails?.map(val => val?.travelerOptionId),
    };

    dispatch(placementModsAction.updateLinkModTask(payload));
  };

  useEffect(() => {
    if (isRecruitment(appUser.userInfo.roles) && !isReadOnly(appUser?.userInfo?.roles || [])) {
      setAddIconDisable(false);
    } else {
      setAddIconDisable(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const rightActions = React.useMemo<IXGridBulkActionButton[]>(() => {
      return [
        {
          KeyId: 'create-add-new-task',
          Icon: TaskAltIcon,
          onClick: () => {},
          disabled: true,
          tooltipProps: {
            tooltipContent: (
              <>
                Create & Link New Task <br />
                Disabled until implemented
              </>
            ),
          },
        },
        {
          KeyId: 'add-link-mod',
          Icon: LinkIcon,
          onClick: handleTaskGridOpen,
          disabled:
            selectedRowDetails?.length === 0 ||
            (rowsToDisplay?.length > 0 && rowsToDisplay[0].isBookingApprovedOrGreater) ||
            isSavingInProgress,
          tooltipProps: {
            tooltipContent: rowsToDisplay[0]?.isBookingApprovedOrGreater
              ? t('placement.profile.edit.disableText')
              : 'Link Task',
          },
        },
        {
          KeyId: 'un-link-mod',
          Icon: LinkOffIcon,
          onClick: onUnLinkClick,
          disabled:
            rowSelectionModel?.length === 0 ||
            !selectedRowDetails?.some(e => e.task) ||
            (rowsToDisplay?.length > 0 && rowsToDisplay[0]?.isBookingApprovedOrGreater) ||
            isSavingInProgress,
          tooltipProps: {
            tooltipContent: rowsToDisplay[0]?.isBookingApprovedOrGreater
              ? t('placement.profile.edit.disableText')
              : 'Unlink Task',
          },
        },
      ];
   
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addIconDisable, selectedRowDetails, rowsToDisplay, placementStatus, isSavingInProgress]);

  const setRawFilter = (keys, payload) => {
    gridFilters?.filters?.forEach(filter => {
      const filterType = filter[0];
      const filterValue = filter[1] as any;
      if (!keys.includes(filterType) && filterValue) {
        if (filterType === PlacementHistoryFilterName.effectiveDate) {
          const startDate = filterValue?.startDate as Date;
          const endDate = filterValue?.endDate as Date;
          payload['startDate'] = new Date(Date.UTC(startDate.getFullYear(), startDate.getMonth(), startDate.getDate()));
          payload['endDate'] = new Date(
            Date.UTC(endDate.getFullYear(), endDate.getMonth(), endDate.getDate(), 23, 59, 59),
          );
        } else if (
          filterType === PlacementHistoryFilterName.recruiterApproved ||
          filterType === PlacementHistoryFilterName.voidStatus
        ) {
          payload[filterType] = filterValue?.value;
        } else if (filterType === PlacementHistoryFilterName.activeMods) {
          payload[filterType] = filterValue?.length === 1 ? filterValue[0].value : null;
        } else {
          payload[filterType] =
            filterValue?.length > 0 ? filterValue?.map(filter => filter?.id)?.toString() : undefined;
        }
      }
    });
  };

  useEffect(() => {
    if (
      gridFilters &&
      gridFilters?.filters?.length &&
      flatten(gridFilters?.filters)[0] === PlacementHistoryFilterName.modType
    ) {
      setPageNumber(1);
      const payload: IPlacementHistoryFilters = getPayloadWithFilters();
      if (resetGridParams) {
        setResetGridParams(false);
        setSortedColumn([]);
      }
      const filterObject = {
        pageNumber: 1,
        pageSize: initialPageSize,
        placementId: Number(params?.placementId),
        endDate: payload?.endDate,
        gridType: null, 
        modTypeIds: payload?.modType,
        modAcceptanceStatusIds: payload?.acceptanceStatus,
        modApprovalStatusIds: payload?.approvalStatus,
        modRecruiterApproved: payload?.recruiterApproved,
        modVoid: payload?.voidStatus,
        offSet: 0,
        startDate: payload?.startDate,
        sortColumn: null,
        sortOrder: null,
      };
      setGridParams(filterObject);
      loadServerRows(filterObject);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gridFilters]);

  const loadServerRows = (request: any = {}) => {    
    const payload = {
      ...gridParams,
      pageNumber: request.pageNumber || 1,
      pageSize: request.pageSize || initialPageSize,
      placementId: Number(params.placementId),
      offSet: request.offSet || 0,
      gridType: null, 
      sortColumn: null,
      sortOrder: null,
      ...request,
    };
    dispatch(placementModsAction.getModificationAction(payload));
  };

  const sortChangeHandelr = model => {
    setSortedColumn(model);
    setPageNumber(1);
    saveSortModel(model);
  };
  const refreshGrid = () => {
    dispatch(placementModsAction.setModificationHistory([]));
    setPageNumber(1);
    setRowsToDisplay([]);
    loadServerRows();
  };

  useEffect(() => {
    if (!tabRendered) {
      dispatch(placementDetailsAction.setModificationTabRendered(true));
    }
    dispatch(gridStateActions.reset());
    
    // Set initial height for infinite scrolling if we expect more than 75 rows
    if (totalCount > maxCount) {
      setGridHeight(600);
      setXgridMinHeight(200);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!gridSelections || gridSelections?.length === 0) {
      setSelectedRowDetails([]);
    }
  }, [gridSelections]);

  useEffect(() => {
    if (historyMods && historyMods.length > 0) {
      const mappedData = [...formatPendingTableData(historyMods)];
      
      setRowsToDisplay(mappedData);
    } else {
      if (pageNumber === 1) {
        setRowsToDisplay([]);
        setTotalCount(0);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [historyMods]);

  const handleCancelChanges = () => {
    setSelectedRowDetails([]);
    setRowSelectionModel([]);
    dispatch(
      gridSelectionActions.setGridSelections({
        selectedData: [],
      }),
    );
  };

  const handleSaveChanges = React.useCallback((newRows: GridRowsProp) => {
    const {
      userInfo: { employeeId },
    } = appUser;

    const modifications = [];
    // const updatedRows = newRows?.filter(newRow => selectedRowDetails?.some(rowDetails => rowDetails.id === newRow.id));

        const updatedRows = newRows?.filter(newRow => {
      // Find the original row data to compare against
      const originalRow = rowsToDisplay?.find(row => row.id === newRow.id);
      if (!originalRow) return false;

      // Check if any editable fields have changed
      const hasAcceptanceChanged = newRow.acceptance !== originalRow.acceptance;

      return hasAcceptanceChanged;
    });

    if (updatedRows.length > 0) {
      updatedRows.map(updatedRow => modifications.push({
        placementId: updatedRow.placementId,
        travelerOptionId: updatedRow.travelerOptionId,
        approvalStatusId: updatedRow.approvalStatusId,
        acceptanceStatusId: AcceptenceStatus[updatedRow.acceptance],
        effectiveDate: getEndOfDate(updatedRow.effectiveDate),
        userId: employeeId,
        voidStatus: updatedRow.voidStatus === 'N' ? false : true,
        travelerOptionTimestamp: updatedRow.travelerOptionTimestamp,
        assignTaskId: updatedRow.assignTaskId,
        assignRootTaskId: updatedRow.assignRootTaskId
      }));

      dispatch(
        placementModsAction.business_batchUpdatePlacementMod({
          placementId: updatedRows?.[0]?.placementId,
          modifications
        }),
      );
    }
  }, [rowsToDisplay, appUser, dispatch]);

  const filterRowCount = (state: GridState) => {
    calcGridHeight(gridFilterRowCount(state));
  };

  useEffect(() => {
    setSelectedRowDetails([]);
    setRowSelectionModel([]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [placementStatus?.currentPlacementStatus]);

  const getColumnPreferences = (cols: any[]) => {
    try {
      const columnPreferences = gridPreferences?.value;
      if (columnPreferences && columnPreferences.columns) {
        const newColumns = cols.map(column => {
          const foundIndex = columnPreferences.columns.findIndex(item => item?.field === column?.field);
          if (foundIndex !== -1) {
            return {
              ...column,
              ...columnPreferences.columns[foundIndex],
            };
          } else {
            return column;
          }
        });
        return newColumns.sort((a, b) => {
          return (
            columnPreferences.columns.findIndex(i => i.field === a.field) -
            columnPreferences.columns.findIndex(i => i.field === b.field)
          );
        });
      }
      return cols;
    } catch (err) {
      return cols;
    }
  };

  const getVisibilityPreferences = (cols: any) => {
    const columnPreferences = gridPreferences?.value;
    if (columnPreferences && columnPreferences?.columnVisibilityModel) {
      return _.merge(_.cloneDeep(cols), columnPreferences?.columnVisibilityModel);
    }
    return _.cloneDeep(cols);
  };

  const determineVisibilityModel = () => {
    const currentVisibilityModel = getVisibilityPreferences(PlacementHistoryVisibilityModel);
    setCurrentColumnVisibilityModel(currentVisibilityModel);
    const visibilityModel = placementHistoryColumn();
    determineGridColumns(visibilityModel);
  };

  const determineGridColumns = (cols: any) => {
    const currentGridColumns = getColumnPreferences(cols);
    setHistoryTableCol(currentGridColumns);
  };

  const determinePinnedColumns = () => {
    if (gridPreferences?.value?.pinnedColumns) {
      setPinnedColumns(gridPreferences?.value?.pinnedColumns);
    }
  };

  const determineFilters = () => {
    if (gridPreferences?.value?.updatedFilter) {
      setFilterModel(gridPreferences?.value?.updatedFilter);
    }
  };

  const determineDensity = () => {
    if (gridPreferences?.value?.gridDensity) {
      setDensity(gridPreferences?.value?.gridDensity);
    }
  };

  const saveSortModel = useSortModelPreference({
    gridTag,
    gridPreferences,
    setShowResetButton,
  });

  const getSortModelPreferences = useGetSortModelPreferences({
    gridPreferences,
  });

  const determineSortModel = React.useCallback(() => {
    const currentGridSortModel = getSortModelPreferences(sortedColumn ?? []);
    setSortedColumn(currentGridSortModel);
  }, [getSortModelPreferences, sortedColumn]);

  const hasNonDefaultGridPreferences = React.useCallback(() => {
    const value = gridPreferences?.value;
    if (!value) {
      return false;
    }

    const savedColumns = new CurrentGridColumns(value.columns, value.columnVisibilityModel);
    const defaultColumns = new CurrentGridColumns(placementHistoryColumn(), _.cloneDeep(PlacementHistoryVisibilityModel));

    return (
      (value.columns?.length > 0 && !savedColumns.isEqual(defaultColumns.columns)) ||
      (value.columnVisibilityModel && !_.isEqual(value.columnVisibilityModel, _.cloneDeep(PlacementHistoryVisibilityModel))) ||
      !_.isEmpty(value.pinnedColumns) ||
      (value.updatedFilter?.items?.length ?? 0) > 0 ||
      (value.gridDensity && value.gridDensity !== 'compact') ||
      Boolean(value.sortedColumn) ||
      (value.multiSortedColumns?.length ?? 0) > 0
    );
  }, [gridPreferences?.value]);

  const savePreferences = React.useCallback(
    ({
      field,
      columns: gridColumns,
      visibilityModel,
    }: {
      field?: string;
      columns: XGridColumns;
      visibilityModel: GridColumnVisibilityModel;
    }) => {
      if (!historyTableCol || historyTableCol.length === 0) {
        return;
      }
      
      const currentGridColumns = new CurrentGridColumns(gridColumns).columns;

      if (currentGridColumns && currentGridColumns.length > 0 && currentGridColumns[0].field === '__check__')
        currentGridColumns.shift();

      const comparableColumns = new CurrentGridColumns(
        gridPreferences?.value?.columns,
        gridPreferences?.value?.columnVisibilityModel,
      );
      const columnsEqual = comparableColumns.isEqual(currentGridColumns);
      const visibilityEqual = comparableColumns.isVisibilityModelEqual(visibilityModel);

      if (!columnsEqual || !visibilityEqual) {
        const preferenceData = {
          id: gridTag,
          value: {
            ...(gridPreferences?.value || {}),
            columns: currentGridColumns,
            columnVisibilityModel: visibilityModel,
          },
        };
        setShowResetButton(true);
        dispatch(userDevicePreferenceActions.saveUserGridPreferenceAction(preferenceData));
      }
    },
    [historyTableCol, gridPreferences?.value, dispatch],
  );

  const handlePinnedColumnsChange = usePinnedColumnsPreference({
    gridTag,
    gridPreferences,
    setPinnedColumns,
    setShowResetButton,
  });

  const saveFilterPreference = React.useCallback(
    (model: GridFilterModel) => {
      setFilterModel(model);
      const preferenceData = {
        id: gridTag,
        value: {
          ...(gridPreferences?.value || {}),
          updatedFilter: model,
        },
      };
      setShowResetButton(true);
      dispatch(userDevicePreferenceActions.saveUserGridPreferenceAction(preferenceData));
    },
    [filterModel, userPreference.loaded, gridPreferences?.value, dispatch],
  );

  React.useEffect(() => {
    if (userPreference?.loaded && gridPreferences) {
      determineVisibilityModel();
      determinePinnedColumns();
      determineFilters();
      determineDensity();
      
      // Restore saved sort model
      const savedModel = getSortModelPreferences([]);
      if (savedModel?.length > 0) {
        setSortedColumn(savedModel);
      } else {
        determineSortModel();
      }
      setShowResetButton(hasNonDefaultGridPreferences());
    }
  }, [userPreference?.loaded, gridPreferences, hasNonDefaultGridPreferences]);

  return (
    <>
      <XGridInlineEdit
        gridTag={gridTag}
        onStateChange={(state) => {
          filterRowCount(state);
          // handle density changes
          if (state.density?.value !== density) {
            setDensity(state.density.value);
            const preferenceData = {
              id: gridTag,
              value: {
                ...(gridPreferences?.value || {}),
                gridDensity: state.density.value,
              },
            };
            setShowResetButton(true);
            dispatch(userDevicePreferenceActions.saveUserGridPreferenceAction(preferenceData));
          }
        }}
        disableMultipleColumnsSorting={false}
        columns={historyTableCol}
        key={`PlacementHistory-${gridFilters}-${gridHeight}`}
        rows={rowsToDisplay}
        onSave={handleSaveChanges}
        onCancel={handleCancelChanges}
        saving={isSavingInProgress}
        isCellEditable={(params) => {
          // Disable editing when saving is in progress
          if (isSavingInProgress) return false;
          
          switch (params.field) {
            case 'acceptance':
              return isCellEditable(params, 'acceptanceStatus');
            default:
              return false;
          }
        }}
        headerHeight={headerHeight}
        style={{
          height: `${gridHeight}px`,
          minHeight: `${Math.max(gridHeight, 400)}px`,
          maxHeight: `${Math.max(gridHeight, 400)}px`,
        }}
        sx={{
          minHeight: `${xgridMinHeight}px`,
          height: `${gridHeight}px`,
          overflow: 'auto',
          '& .MuiDataGrid-virtualScroller': {
            height: 'auto !important',
            overflow: 'auto !important',
          },
          '& .MuiDataGrid-main': {
            overflow: 'auto !important',
          },
        }}
        height={gridHeight}
        checkboxSelection
        title={t('placement.placementHistory.tableTitle')}
        pagination={false}
        className={classes.grid}
        hideFooter
        onCellDoubleClick={onCellDoubleClick}
        onSelectionModelChange={ids => onRowsSelectionHandler(ids)}
        keepNonExistentRowsSelected={true}
        defaultColumnVisibilityModel={PlacementHistoryVisibilityModel}
        columnVisibilityModel={currentColumnVisibilityModel}
        onSortModelChange={sortChangeHandelr}
        sortingMode="client"
        sortModel={sortedColumn}
        loading={isCallingAPI}
        disableSelectionOnClick={true}
        showSelectedRowCount={true}
        rowCount={totalCount}
        rowCountDisplay={totalCount}
        rowBuffer={10}
        onColumnVisibilityModelChange={(model, details) => {
          const nextVisibilityModel = _.cloneDeep(model);
          if (expectedResetVisibilityModelRef.current) {
            if (_.isEqual(nextVisibilityModel, expectedResetVisibilityModelRef.current)) {
              expectedResetVisibilityModelRef.current = null;
              setCurrentColumnVisibilityModel(nextVisibilityModel);
              return;
            }
          }
          if (_.isEqual(nextVisibilityModel, currentColumnVisibilityModel)) {
            return;
          }
          setCurrentColumnVisibilityModel(nextVisibilityModel);
          savePreferences({
            field: undefined,
            columns: _.cloneDeep(historyTableCol),
            visibilityModel: nextVisibilityModel,
          });
        }}
        onColumnResizeStop={_columns => {
          savePreferences({
            field: undefined,
            columns: _columns,
            visibilityModel: _.cloneDeep(currentColumnVisibilityModel),
          });
        }}
        onColumnOrderChange={(params, event, details, _columns) => {
          savePreferences({
            field: params.field,
            columns: _columns,
            visibilityModel: _.cloneDeep(currentColumnVisibilityModel),
          });
        }}
        pinnedColumns={pinnedColumns}
        onPinnedColumnsChange={handlePinnedColumnsChange}
        filterModel={filterModel}
        onFilterModelChange={saveFilterPreference}
        density={density}
        toolbarProps={{
          rightActions: rightActions,
          refreshButton: true,
          resetButton: showResetButton,
          resetColumns: () => {
            const defaultColumns = placementHistoryColumn();
            const defaultVisibilityModel = _.cloneDeep(PlacementHistoryVisibilityModel);
            expectedResetVisibilityModelRef.current = defaultVisibilityModel;
            setHistoryTableCol(defaultColumns);
            setCurrentColumnVisibilityModel(defaultVisibilityModel);
            setPinnedColumns({});
            setFilterModel({ items: [] });
            setDensity('compact');
            setSortedColumn([]);
            setShowResetButton(false);
            // clear preferences
            const preferenceData = {
              id: gridTag,
              value: {
                columns: defaultColumns,
                columnVisibilityModel: defaultVisibilityModel,
                pinnedColumns: {},
                gridDensity: 'compact',
                updatedFilter: { items: [] },
              },
            };
            dispatch(userDevicePreferenceActions.saveUserGridPreferenceAction(preferenceData));
          },
          refreshGrid: refreshGrid,
        }}
        getRowClassName={getRowClassName}
      />
      <ReplaceTasks
        openDialog={openReplaceTasks}
        handleConfirmAction={() => {
          dispatch(placementModsAction.setOpenTaskGrid(selectedRowDetails));
          setOpenReplaceTasks(false);
        }}
        handleCancelAction={() => {
          setOpenReplaceTasks(false);
        }}
      />
      <UnLinkTasks
        openDialog={openUnlink}
        handleConfirmAction={() => {
          saveUnlinkMods();
          setOpenUnlink(false);
        }}
        handleCancelAction={() => {
          setOpenUnlink(false);
        }}
      />
    </>
  );
};

export default PlacementHistoryGrid;
